import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { RootState } from "store"
import type { IChapter } from "types/chapterTypes"

interface ChapterState {
  chapters: Array<IChapter>
  currentChapter: IChapter | undefined
}

const initialState: ChapterState = {
  chapters: [] as IChapter[],
  currentChapter: undefined,
}

export const chapterSlice = createSlice({
  name: "chapter",
  initialState,
  reducers: {
    setChapters: (state, action: PayloadAction<Array<IChapter>>) => {
      state.chapters = action.payload
    },
    setCurrentChapter: (state, action: PayloadAction<IChapter>) => {
      state.currentChapter = action.payload
    },
    addChapter: (state, action: PayloadAction<IChapter>) => {
      state.chapters?.push(action.payload)
    },
    updateChapter: (state, action: PayloadAction<IChapter>) => {
      var index = state.chapters.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.chapters[index] = action.payload
      }
    },
    removeChapter: (state, action: PayloadAction<IChapter>) => {
      var index = state.chapters.findIndex((x) => x.id === action.payload.id)

      if (index !== -1) {
        state.chapters.splice(index, 1)
      }
    },
    resetChapter: (state, _action) => {
      state.chapters = []
      state.currentChapter = undefined
    },
  },
})

export const {
  setChapters,
  addChapter,
  updateChapter,
  removeChapter,
  setCurrentChapter,
  resetChapter,
} = chapterSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectCount = (state: RootState) => state.chapter

export default chapterSlice.reducer
